module.exports = __webpack_public_path__ + "img/medical-earth.8ba1237.svg";